import { useCallback, useEffect, useState } from 'react';
import { GetAdminTutorialsStatsAPI } from '../../../../api/AdminAPI';

/**
 * useAdminTutorialsStats
 *
 * Números dos tutoriais por lição (admin/tutorials/stats.php), somando todas as empresas.
 * Por padrão ficam de fora as empresas de teste e os admins da plataforma.
 *
 * @returns {Object} estado e ações da tela
 */
function useAdminTutorialsStats() {
  const [includeTest, setIncludeTest] = useState(false);
  const [statsById, setStatsById] = useState({});
  const [totals, setTotals] = useState({ users: 0, companies: 0 });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(() => {
    setIsLoading(true);
    setError(null);
    GetAdminTutorialsStatsAPI({ include_test: includeTest ? 1 : 0 }, (response) => {
      if (!response || response.success === false) {
        setError(response?.error || 'Erro ao carregar os números dos tutoriais. Tente novamente.');
        setIsLoading(false);
        return;
      }
      setStatsById(Object.fromEntries((response.lessons || []).map((row) => [row.lesson_id, row])));
      setTotals(response.totals || { users: 0, companies: 0 });
      setIsLoading(false);
    });
  }, [includeTest]);

  useEffect(() => { refresh(); }, [refresh]);

  return { statsById, totals, isLoading, error, includeTest, setIncludeTest, refresh };
}

export default useAdminTutorialsStats;
